import React from 'react';
import { cx } from 'linaria';
import { styled } from 'linaria/react';
const BadgeWrapper = /*#__PURE__*/styled('div')({
  name: "BadgeWrapper",
  class: "bw5nwwd"
});
const BadgeStyle = /*#__PURE__*/styled('div')({
  name: "BadgeStyle",
  class: "b1sx4slz"
});
const BadgeTopLeftWrapper = /*#__PURE__*/styled(BadgeStyle)({
  name: "BadgeTopLeftWrapper",
  class: "b11hbbze"
});
const BadgeTopRightWrapper = /*#__PURE__*/styled(BadgeStyle)({
  name: "BadgeTopRightWrapper",
  class: "bjfg2yl"
});
const BadgeBottomLeftWrapper = /*#__PURE__*/styled(BadgeStyle)({
  name: "BadgeBottomLeftWrapper",
  class: "bjxrflz"
});
const BadgeBottomRightWrapper = /*#__PURE__*/styled(BadgeStyle)({
  name: "BadgeBottomRightWrapper",
  class: "ba873gr"
});
const ProductBadgeComponent = /*#__PURE__*/styled('div')({
  name: "ProductBadgeComponent",
  class: "p1kgh9s4"
});

const Badge = ({
  badge
}) => {
  return React.createElement(ProductBadgeComponent, {
    className: cx(badge.style, badge.url && 'with-badge')
  }, React.createElement("span", null, badge.text), badge.url && React.createElement("img", {
    src: badge.url,
    alt: badge.name
  }));
};

const Badges = ({
  badges = []
}) => {
  if (badges.length === 0) return null;
  const topLeftBadges = badges.filter(badge => badge.location === 'TOP_LEFT');
  const topRightBadges = badges.filter(badge => badge.location === 'TOP_RIGHT');
  const bottomLeftBadges = badges.filter(badge => badge.location === 'BOTTOM_LEFT');
  const bottomRightBadges = badges.filter(badge => badge.location === 'BOTTOM_RIGHT');
  return React.createElement(BadgeWrapper, null, topLeftBadges.length > 0 && React.createElement(BadgeTopLeftWrapper, {
    className: "badge-top-left"
  }, topLeftBadges.map(badge => React.createElement(Badge, {
    key: badge.name,
    badge: badge
  }))), topRightBadges.length > 0 && React.createElement(BadgeTopRightWrapper, {
    className: "badge-top-right"
  }, topRightBadges.map(badge => React.createElement(Badge, {
    key: badge.name,
    badge: badge
  }))), bottomLeftBadges.length > 0 && React.createElement(BadgeBottomLeftWrapper, {
    className: "badge-bottom-left"
  }, bottomLeftBadges.map(badge => React.createElement(Badge, {
    key: badge.name,
    badge: badge
  }))), bottomRightBadges.length > 0 && React.createElement(BadgeBottomRightWrapper, {
    className: "badge-bottom-right"
  }, bottomRightBadges.map(badge => React.createElement(Badge, {
    key: badge.name,
    badge: badge
  }))));
};

export default Badges;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/ProductList/Badges.linaria.css");